import {
  useToggleDeviceActivityMutation,
  useMoveDeviceToFirmMutation,
  useMoveDeviceToPlaymakerMutation,
  useMoveDeviceToServiceMutation,
} from "../../store/storageRoles/devicesApi";

export const useDeviceOperationData = () => {
  const [toggleDeviceActivity, resultToggleDeviceActivity] =
    useToggleDeviceActivityMutation();
  const [moveDeviceToFirm, resultMoveDeviceToFirm] =
    useMoveDeviceToFirmMutation();
  const [moveDeviceToPlaymaker, resultMoveDeviceToPlaymaker] =
    useMoveDeviceToPlaymakerMutation();
  const [moveDeviceToService, resultMoveDeviceToService] =
    useMoveDeviceToServiceMutation();

  // Combine loading/error/success states from all mutations
  const isLoading =
    resultToggleDeviceActivity.isLoading ||
    resultMoveDeviceToFirm.isLoading ||
    resultMoveDeviceToPlaymaker.isLoading ||
    resultMoveDeviceToService.isLoading;

  const isError =
    resultToggleDeviceActivity.isError ||
    resultMoveDeviceToFirm.isError ||
    resultMoveDeviceToPlaymaker.isError ||
    resultMoveDeviceToService.isError;

  const isSuccess =
    resultToggleDeviceActivity.isSuccess ||
    resultMoveDeviceToFirm.isSuccess ||
    resultMoveDeviceToPlaymaker.isSuccess ||
    resultMoveDeviceToService.isSuccess;

  const errorMessage =
    resultToggleDeviceActivity.error?.data?.message ||
    resultMoveDeviceToFirm.error?.data?.message ||
    resultMoveDeviceToPlaymaker.error?.data?.message ||
    resultMoveDeviceToService.error?.data?.message;

  const successData =
    resultToggleDeviceActivity.data?.data ||
    resultMoveDeviceToFirm.data?.data ||
    resultMoveDeviceToPlaymaker.data?.data ||
    resultMoveDeviceToService.data?.data;

  return {
    deviceOperationIsLoading: isLoading,
    deviceOperationIsError: isError,
    deviceOperationIsSuccess: isSuccess,
    deviceOperationErrorMessage: errorMessage,
    deviceOperationSuccessMessage: "Cihaz güncellendi!",
    deviceOperationData: successData,
    toggleDeviceActivity,
    moveDeviceToFirm,
    moveDeviceToPlaymaker,
    moveDeviceToService,
  };
};
